import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import './styles.scss';
import './analytics';

import { BrowserRouter } from "react-router-dom";
import SharedContextProvider from "./context/shared.context";
import LeadServiceContextProvider from "./context/lead-service.context";
import IntegrationsContextProvider from "./context/integrations.context";
import AuthContextProvider from "./context/auth.context";
import DocumentsContextProvider from './context/documents.context';

import UserContextProvider from './context/user.context';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <SharedContextProvider>
      <LeadServiceContextProvider>
        <IntegrationsContextProvider>
          <AuthContextProvider>
            <UserContextProvider>
              <DocumentsContextProvider>
                <App/>
              </DocumentsContextProvider>
            </UserContextProvider>
          </AuthContextProvider>
        </IntegrationsContextProvider>
      </LeadServiceContextProvider>
    </SharedContextProvider>
  </BrowserRouter>
);

